:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._container_hotlc_7 {
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none; }
  ._container_hotlc_7._enabledPointerEvents_hotlc_15 {
    pointer-events: all;
    background-color: transparent; }
    ._container_hotlc_7._enabledPointerEvents_hotlc_15._hovered_hotlc_18 {
      z-index: 1; }
  ._container_hotlc_7._bothSelectedAndHovered_hotlc_20:before, ._container_hotlc_7._bothSelectedAndHovered_hotlc_20:after,
  ._container_hotlc_7._bothSelectedAndHovered_hotlc_20 ._frame_hotlc_21, ._container_hotlc_7._selected_hotlc_21:before, ._container_hotlc_7._selected_hotlc_21:after,
  ._container_hotlc_7._selected_hotlc_21 ._frame_hotlc_21 {
    border-color: #fe620f; }
  ._container_hotlc_7._overlay_hotlc_24 {
    background-color: rgba(254, 98, 15, 0.1); }
  ._container_hotlc_7:before, ._container_hotlc_7:after {
    content: '';
    width: 100%;
    position: absolute;
    pointer-events: none; }
  ._container_hotlc_7:before {
    border-top: 3px solid #fdd1ba; }
  ._container_hotlc_7._footer_hotlc_33:before {
    top: 0; }
  ._container_hotlc_7:after {
    border-bottom: 3px solid #fdd1ba;
    bottom: 0; }
  ._container_hotlc_7._mouseOpsInProgress_hotlc_38 {
    background-color: transparent; }

._resizeHandleContainer_hotlc_41 {
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 100;
  pointer-events: all;
  cursor: pointer;
  left: 70%;
  bottom: 0; }
  ._resizeHandleContainer_hotlc_41._mobileEditor_hotlc_50 {
    left: auto; }

._emptyStateContainer_hotlc_53 {
  display: flex;
  height: 100%;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: all;
  z-index: 100; }
  ._emptyStateContainer_hotlc_53._liteMode_hotlc_61 {
    flex-direction: row;
    align-items: center; }
  ._emptyStateContainer_hotlc_53 ._textContainer_hotlc_64 {
    display: inline-block;
    margin-top: 3px;
    margin-right: 5px;
    line-height: 18px; }
  ._emptyStateContainer_hotlc_53 ._linksContainer_hotlc_69,
  ._emptyStateContainer_hotlc_53 > .control-text {
    color: #3b4057; }
  ._emptyStateContainer_hotlc_53._light_hotlc_72 ._linksContainer_hotlc_69,
  ._emptyStateContainer_hotlc_53._light_hotlc_72 > .control-text {
    color: #fff; }
  ._emptyStateContainer_hotlc_53 ._linksContainer_hotlc_69 {
    display: inline-block;
    margin-top: 3px;
    line-height: 18px; }
    ._emptyStateContainer_hotlc_53 ._linksContainer_hotlc_69 > .control-text-button {
      vertical-align: bottom; }

._frame_hotlc_21 {
  border: 3px solid #fdd1ba;
  border-bottom: 0;
  border-top: 0;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; }
